module.exports = __webpack_public_path__ + "static/media/HomeHeader-bg-mobile-@2x.c274d563.png";